import React, { useEffect, useState } from "react";
import UserRoleForm from "./UserRoleForm";
import { API_URL } from "../../../../Constant";
import useAxios from "../../../../Utils/useAxios";
import EditButton from "../../../../CommonElements/Button/EditButton";
import CreateButton from "../../../../CommonElements/Button/CreateButton";
import PengaturanModal from "../../../../Layout/Components/PengaturanModal";

const UserRoleModal = ({ create, ur }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  const [title] = useState(
    create ? "Form Penambahan Unit Role" : "Sunting Unit Role"
  );
  const [button] = useState(
    create ? (
      <CreateButton toggle={toggle}>Buat User Role Baru</CreateButton>
    ) : (
      <EditButton toggle={toggle} />
    )
  );

  const [unitkerja, setUnitkerja] = useState([]);

  let isMounted = false;
  useEffect(() => {
    isMounted = true;

    getUnitKerjaUR();

    return () => {
      isMounted = false;
    };
  }, []);

  const axiosInstance = useAxios();

  const getUnitKerjaUR = () => {
    if (isMounted) {
      axiosInstance
        .get(API_URL + "unitkerja/")
        .then((res) => setUnitkerja(res.data));
    }
  };

  const resetState = () => {
    getUnitKerjaUR();
  };

  return (
    <PengaturanModal
      button={button}
      title={title}
      isOpen={isOpen}
      toggle={toggle}
    >
      <UserRoleForm
        resetState={() => resetState()}
        toggle={() => toggle()}
        ur={ur}
        unitkerja={unitkerja}
        setUnitkerja={setUnitkerja}
      />
    </PengaturanModal>
  );
};

export default UserRoleModal;
